import { render, staticRenderFns } from "./MemberBoard.vue?vue&type=template&id=533567e4&scoped=true"
import script from "./MemberBoard.vue?vue&type=script&lang=js"
export * from "./MemberBoard.vue?vue&type=script&lang=js"
import style0 from "./MemberBoard.vue?vue&type=style&index=0&id=533567e4&prod&lang=scss&scoped=true"
import style1 from "./MemberBoard.vue?vue&type=style&index=1&id=533567e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533567e4",
  null
  
)

export default component.exports